import type { TranslationDict } from '../en';

const ko: TranslationDict = {
  'header.buy': '구매',
  'header.sell': '판매',
  'spend.label': '지출 금액',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': '수령 금액',
  'payment.label': '결제 수단',
  'payment.select': '선택',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': '이 거래 쌍에 사용 가능한 결제 수단이 없습니다',
  'wallet.label': '수신 지갑 주소',
  'wallet.placeholderBuy': '수신 주소를 입력하세요',
  'wallet.placeholderSell': '발신 주소를 입력하세요',
  'wallet.validating': '주소 확인 중...',
  'wallet.invalid': '유효한 지갑 주소를 입력하세요',
  'wallet.invalidServer': '잘못된 지갑 주소',
  'cta.buy': '{crypto} 구매',
  'cta.sell': '{crypto} 판매',
  'cta.gettingPrice': '최적의 가격을 가져오는 중...',
  'cta.processing': '처리 중...',
  'footer.poweredBy': 'Powered by ',
  'footer.brand': 'NowRamp',
  'rate.title': '환율 내역',
  'rate.close': '닫기',
  'rate.updatesIn': '환율 갱신까지 00:{seconds}',
  'rate.noQuote': '견적을 사용할 수 없습니다',
  'rate.exchangeRate': '환율',
  'rate.processingFee': '처리 수수료',
  'rate.networkFee': '네트워크 수수료',
  'rate.provider': '제공업체',
  'toast.orderCreated': '주문이 생성되었습니다',
  'toast.redirecting': '결제 페이지로 이동 중...',
  'toast.orderFailed': '주문 실패',
  'toast.couldNotCreate': '주문을 생성할 수 없습니다',
  'toast.quoteError': '견적 오류',
  'toast.noProviders': '제공업체 없음',
  'toast.somethingWrong': '문제가 발생했습니다',
  'error.amountZero': '금액은 0보다 커야 합니다',
  'error.minAmountFiat': '최소 금액은 {min} {currency}입니다',
  'error.minAmountCrypto': '최소 금액은 {min} {currency}입니다',
  'error.noProviders': '이 조합에 사용 가능한 제공업체가 없습니다',
  'error.currencyUnavailableBuy': '이 통화는 구매 주문에 사용할 수 없습니다',
  'error.currencyUnavailableSell': '이 통화는 판매 주문에 사용할 수 없습니다',
  'parity.info': '{receiveAmount} {crypto}가 청구되며, {spendAmount} {fiat}까지의 나머지 금액은 {partner} 계정에 적립됩니다',
  'redirect.secureBadge': '안전한 결제',
  'redirect.title': '결제 계속하기',
  'redirect.description': '결제를 완료하기 위해 {gateway}(으)로 이동합니다.',
  'redirect.countdown': '{seconds} 후 이동합니다...',
  'redirect.openTab': '새 탭에서 ACH 열기',
  'redirect.cancel': '취소',
  'checkout.noOrder': '주문을 찾을 수 없습니다',
  'checkout.goBack': '돌아가기',
  'checkout.expired': '결제 만료',
  'checkout.expiredDesc': '세션이 만료되었습니다. 다시 시도해 주세요.',
  'checkout.startOver': '처음부터 다시',
  'checkout.cancel': '취소',
  'checkout.loading': '결제 페이지 로딩 중...',
  'checkout.iframeTitle': '제공업체 결제',
  'checkout.widgetTitle': '결제 화면',
  'checkout.unknownMethod': '알 수 없는 결제 방식',
  'processing.default': '주문을 처리하는 중...',
  'processing.pending': '결제 확인을 기다리는 중...',
  'processing.active': '거래를 처리하는 중...',
  'processing.generic': '처리 중...',
  'processing.checkingStatus': '상태 확인 중...',
  'processing.orderId': '주문 ID',
  'processing.provider': '제공업체',
  'processing.amount': '금액',
  'processing.receiving': '수령',
  'processing.network': '네트워크',
  'processing.toAddress': '수신 주소',
  'processing.usuallyMinutes': '보통 몇 분 정도 소요됩니다.',
  'processing.safeToClose': '이 페이지를 닫으셔도 됩니다. 완료되면 이메일로 알려드리겠습니다.',
  'complete.buyTitle': '구매 완료!',
  'complete.sellTitle': '판매 완료!',
  'complete.buyDesc': '{crypto}이(가) 지갑으로 전송되었습니다.',
  'complete.sellDesc': '{fiat} 출금이 처리 중입니다.',
  'complete.amountBuy': '수령 금액',
  'complete.amountSell': '판매 금액',
  'complete.paidBuy': '결제 금액',
  'complete.paidSell': '출금 금액',
  'complete.network': '네트워크',
  'complete.wallet': '지갑',
  'complete.transaction': '트랜잭션',
  'complete.provider': '제공업체',
  'complete.orderId': '주문 ID',
  'complete.completed': '완료됨',
  'complete.viewExplorer': '탐색기에서 보기',
  'complete.done': '완료',
  'errorStep.failed': '결제 실패',
  'errorStep.cancelled': '주문 취소됨',
  'errorStep.expired': '주문 만료됨',
  'errorStep.refunded': '주문 환불됨',
  'errorStep.unknown': '문제가 발생했습니다',
  'errorStep.failedBuy': '결제를 처리할 수 없습니다. 다시 시도하거나 다른 결제 수단을 사용해 주세요.',
  'errorStep.failedSell': '판매를 처리할 수 없습니다. 다시 시도해 주세요.',
  'errorStep.cancelledBuy': '주문이 취소되었습니다. 결제가 처리되지 않았습니다.',
  'errorStep.cancelledSell': '판매가 취소되었습니다. 암호화폐가 전송되지 않았습니다.',
  'errorStep.expiredBuy': '주문이 만료되었습니다. 새로운 구매를 시작해 주세요.',
  'errorStep.expiredSell': '주문이 만료되었습니다. 새로운 판매를 시작해 주세요.',
  'errorStep.refundedBuy': '결제가 환불되었습니다. 5~10 영업일 이내에 계정에 반영됩니다.',
  'errorStep.refundedSell': '암호화폐가 반환되었습니다. 곧 지갑에 반영될 예정입니다.',
  'errorStep.genericDesc': '예상치 못한 오류가 발생했습니다. 다시 시도해 주세요.',
  'errorStep.orderId': '주문 ID',
  'errorStep.tryAgain': '다시 시도',
  'errorStep.startOver': '처음부터 다시',
  'errorStep.return': '돌아가기',
  'errorStep.needHelp': '도움이 필요하신가요? 문의처: ',
  'errorStep.reference': '참조 번호: {orderId}',
  'confirm.buyTitle': '구매 확인',
  'confirm.sellTitle': '판매 확인',
  'confirm.loading': '로딩 중...',
  'confirm.provider': '제공업체',
  'confirm.youPay': '결제 금액',
  'confirm.youSell': '판매 금액',
  'confirm.youReceive': '수령 금액',
  'confirm.wallet': '지갑',
  'confirm.network': '네트워크',
  'confirm.refundAddress': '환불 주소',
  'confirm.parityNote': '제공업체의 실제 청구 금액이 다를 수 있습니다. {amount} {crypto}까지의 나머지 금액은 {partner} 계정에 적립됩니다.',
  'confirm.processing': '처리 중...',
  'confirm.confirmPay': '확인 후 결제',
  'confirm.confirmSell': '확인 후 판매',
  'confirm.payout': '{currency} 출금',
  'modal.selectFiat': '법정 화폐 선택',
  'modal.selectCrypto': '암호화폐 선택',
  'modal.choosePayment': '결제 수단 선택',
  'modal.selectCountry': '국가를 선택하세요',
  'modal.selectLanguage': 'Select language',
  'modal.popular': '인기',
  'modal.recommended': '추천',
  'modal.noCurrencies': '통화를 찾을 수 없습니다',
  'modal.noPaymentMethods': '결제 수단을 찾을 수 없습니다',
  'modal.noCountries': '국가를 찾을 수 없습니다',
  'modal.noLanguages': 'No languages found',
  'settings.location': '위치',
  'settings.darkMode': '다크 모드',
  'settings.privacy': '개인정보 처리방침',
  'settings.terms': '이용약관',
  'settings.language': '언어',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp 선택',
  'modal.bestPrice': '최저가',
  'modal.noQuotes': '이 요청에 사용 가능한 견적이 없습니다',
  'modal.noProvidersFound': '제공업체를 찾을 수 없습니다',
  'payment.unavailableFor': '{currency}에 사용 가능한 결제 수단이 없습니다',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': '주문 생성에 실패했습니다',
  'errorStep.returnToMerchant': '판매자로 돌아가기',
  'confirm.cryptoOnNetwork': '{network}의 {crypto}',
  'payment.name.card': '카드',
  'payment.name.bankTransfer': '은행 송금',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default ko;
